<template>
  <div
    class="mats-listing__wrapper color-listing__wrapper"
  >
    <div
      class="toolbar"
      style="height: 62px"
    />
    <div style="width: 100%; margin-top: 0px">
      <table
        class="team_table"
        :class="{'button--disabled': getArticleOrders.length == 0}"
      >
        <thead>
          <tr>
            <th>
              {{ $t('ArticleName') }}
            </th>
            <th>
              {{ $t('State') }}
            </th>
            <th>
              {{ $t('CurrentTeam') }}
            </th>
          </tr>
        </thead>
        <LoadingSpinnerTable
          v-if="orderId != ''"
          :is-loading="isRequestLoading('readOrderItems')"
          :response-data="filteredArticleOrders"
        >
          <tr
            v-for="(item, index) in filteredArticleOrders"
            :key="index"
            :style="classNameCh === item.orderNumber ? '' : ''"
            @click="matProps(item)"
          >
            <td>
              {{ item.articleName }}
            </td>
            <td
              v-b-tooltip.hover.top
              v-b-modal.admin-state-modal
              :title="$t('ChangeState')"
              @click="returnState(item.windowId,item.stateDtos[item.state].stateName)"
            >
              <button
                size="sm"
                class="button"
              >
                {{ $t(item.stateDtos[item.state].stateName) }}
              </button>
            </td>
            <td>
              <button
                v-if=" item.teamName == null || item.teamName == ''"
                v-b-tooltip.hover.top
                v-b-modal.admin-team-modal
                :title="$t('ChangeTeam')"
                class="button"
                size="sm"
                @click="getOrderItem(item.windowId, item.teamName)"
              >
                {{ $t('AssignTeam') }}
              </button>
              <button
                v-else-if=" item.teamName != null || item.teamName != ''"
                v-b-tooltip.hover.top
                v-b-modal.admin-team-modal
                :title="$t('ChangeTeam')"
                class="button"
                size="sm"
                @click="getOrderItem(item.windowId, item.teamName)"
              >
                {{ item.teamName }}
              </button>
            </td>
          </tr>
        </LoadingSpinnerTable>
      </table>
    </div>
    <div>
      <b-pagination
        v-if="getTotalItemsForOrderItems > 15"
        v-model="page"
        :total-rows="getTotalItemsForOrderItems"
        :per-page="pageSize"
        first-number
        last-number
        align="fill"
        size="md"
        prev-class="prev-item"
        next-class="next-item"
        class="mt-1 mb-0"
      >
        <template #prev-text>
          <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
        </template>
        <template #next-text>
          <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
        </template>
      </b-pagination>
    </div>
    <AdminTeamModal
      :selected-team="selectedTeam"
      @assign="addTeamToArticle"
    />
    <AdminStateModal
      :selected-state="selectedState"
      @state="newStateAdmin"
    />
    <SellArticleModal
      :order-number="orderItemId"
      :article-name="articleee"
      @sellDresss="sellProductInStock"
    />
    <div
      v-if="isSidebarOpen"
      class="backdrop"
    />
    <EditOrderItemModal
      :article-number="articleNumber"
      @editOrderItemm="edittOrder"
    />
    <EditOrderItemToggle
      :article-number="articleNumber"
      @onCancelToggle="onCancelToggle"
      @editOrderItemm="edittOrder"
    />
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
// import AddTeamModal from '@/components/orders/modals/AddTeamModal.vue';
import { mapActions, mapGetters } from 'vuex';
import SellArticleModal from '@/components/orders/modals/SellArticleOrderModal.vue'
import EditOrderItemModal from '@/components/orders/modals/EditOrderItemModal.vue'
import { client } from '@/domainConfig'
import EditOrderItemToggle from '@/components/orders/modals/EditOrderItemToggle.vue'
import AdminTeamModal from './modals/AdminTeamModal.vue'
// eslint-disable-next-line no-unused-vars
// import Spinner from '../Spinner/Spinner.vue';
import AdminStateModal from './modals/AdminStateModal.vue'


export default {
  components: {
    AdminTeamModal,
    SellArticleModal,
    EditOrderItemModal,
    AdminStateModal,
    EditOrderItemToggle,
    // Spinner,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['orderId', 'createOrder', 'orderStateOfOrder', 'orderIdToResend'],
  data() {
    return {
      isSidebarOpen: false,

      initialId: '',
      materialPropId: '',
      client: client.clientName,
      status: true,
      classNameCh: '',
      articleee: null,
      searchTerm: '',
      rows: [],
      articleNumber: null,
      orderItemId: null,
      materialObject: {},
      editMat: {},
      selectedOrderItem: '',
      selectedTeam: '',
      selectedState: '',
      ord: '',
      page: 1,
      pageSize: 15,
      idToSend: this.orderId,
      stages: [
        {
          value: 0,
          name: 'Created',
        },
        {
          value: 1,
          name: 'Assigned',
        },
        {
          value: 2,
          name: 'Confirmed',
        },
        {
          value: 3,
          name: 'InProduction',
        },
        {
          value: 4,
          name: 'InSewing',
        },
        {
          value: 5,
          name: 'InHandSewing',
        },
        {
          value: 6,
          name: 'QualityPassed',
        },
        {
          value: 7,
          name: 'ReadyToDeliver',
        },
        {
          value: 8,
          name: 'Delivered',
        },
        {
          value: 9,
          name: 'StockNotAvailable',
        },
        {
          value: 10,
          name: 'QualityCheckNotPassed',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['getArticleOrders', 'getCurrentPageForCreatedOrders', 'getTotalItemsForOrderItems', 'getCurrentPageForOrderItems', 'getIsLoading', 'getLoggedInUser', 'getArticleOrders', 'getOrderItemStates']),
    rowsEr() {
      return this.rows.filter((post) => {
        return post.orderNumber.toLowerCase().includes(this.searchTerm.toLowerCase());
      });
    },
    filteredArticleOrders() {
      return this.getArticleOrders.filter((item) => { return item.stateDtos[item.state].stateName !== 'Delivered' });
    },
    showCurrentTeam() {
      return this.filteredArticleOrders.some((item) => { return item.stateDtos[item.state].stateName !== 'Cancelled' });
    },
    getOrderItemStateName() {
      return (stateValue) => {
        const stage = this.stages.find((stageee) => { return stageee.value === stateValue });
        return stage ? stage.name : '';
      };
    },
  },
  watch: {
    initialId() {
      this.immediateId(this.initialId);
    },
    page(value) {
      // this.changeLoadingtoTrue(false)

      this.loadCreatedOrdersByOrderNumber({
        id: this.orderId,
        pageNumber: value,
        pageSize: this.pageSize,
        successCallback: () => {
          // this.changeLoadingtoTrue(true)
        },
      });
    },
  },
  methods: {
    ...mapActions(['getMaterialVariantsToMDCPagination', 'adminOrdersOverview', 'edit_OrderItem', 'teamNames', 'loadCreatedOrdersByOrderNumber', 'assignOrderItemToTeamLeader', 'loadCreatedOreders', 'changeLoadingtoTrue', 'resetCreatedOrdersByOrderNumber', 'getTeamNamesPagination', 'sell_productInStock', 'get_edit_OrderItem', 'edit_OrderItem_MaterialVariants', 'readOrderItems', 'editTeamAdmin', 'orderItemStates', 'editStateAdmin', 'getOrderItemsManagementBy', 'getLanguage']),
    edittOrder(value) {
      this.edit_OrderItem({
        object: value,
        successCallback: () => {
          this.loadCreatedOrdersByOrderNumber({
            id: this.orderId,
            pageNumber: this.page,
            pageSize: this.pageSize,
            successCallback: () => {
              // this.changeLoadingtoTrue(true)
            },
          });
        },
      })
    },
    returnState(orderItem, selectState) {
      this.orderItemStates()
      this.selectedOrderItem = orderItem
      this.selectedState = selectState
    },
    getOrderItem(orderItem, teamName) {
      this.teamNames({
        pageNumber: 1,

        pageSize: 15,

      });
      this.selectedOrderItem = orderItem
      this.selectedTeam = teamName
    },
    articleForTitle(value) {
      this.articleNumber = value
    },
    async addTeamToArticle(obj) {
      const objToSend = {
        orderNumber: this.orderId,
        windowItemId: this.selectedOrderItem,
        newTeamNameId: obj.value,
        notes: null,
      };
      await this.editTeamAdmin({
        object: objToSend,
        successCallback: () => {
          this.readOrderItems({
            orderId: this.orderIdToResend,
            orderItemState: this.selectedOrderState == null ? null : this.selectedOrderState,
          })
          this.adminOrdersOverview({
            pageNumber: this.page,
            pageSize: this.pageSize,
            orderNumber: null,
            clientId: null,
            orderType: null,
            orderState: null,
          })
        },
      });
    },
    async newStateAdmin(obj) {
      const objToSend = {
        orderNumber: this.orderId,
        windowItemId: this.selectedOrderItem,
        newState: obj.teamName,
        newTeamNameId: null,
        notes: obj.notes,
      };
      await this.editStateAdmin({
        object: objToSend,
        successCallback: () => {
          this.readOrderItems({
            orderId: this.orderIdToResend,
            orderItemState: this.selectedOrderState == null ? null : this.selectedOrderState,
          })
          this.adminOrdersOverview({
            pageNumber: this.page,
            pageSize: this.pageSize,
            orderNumber: null,
            clientId: null,
            orderType: null,
            orderState: null,
          })
        },
      });
    },
    sellArticleTeamName() {
      this.getTeamNamesPagination({
        pageNumber: 1,
        pageSize: this.pageSize,
      })
    },
    getEditOrderItemm(value) {
      this.isSidebarOpen = true
      this.get_edit_OrderItem(value)
      this.getMaterialVariantsToMDCPagination({
        pageNumber: 1,
        pageSize: 15,
        measurement: 'Meter',
      })
      this.getMaterialVariantsToMDCPagination({
        pageNumber: 1,
        pageSize: 15,
        measurement: 'Part',
      })
    },
    onCancelToggle() {
      this.isSidebarOpen = false
    },
    getEditOrderItemMaterialVariant(value) {
      this.edit_OrderItem_MaterialVariants(value)
    },
    orderItemID(value) {
      this.orderItemId = value
    },

    sellProductInStock(value) {
      console.log('dbb', value)
      this.sell_productInStock({
        orderItemId: value.orderItemId,
        articleNumber: value.articleNumber,
        assignmentTeamNameId: value.assignmentTeamNameId,
        successCallback: () => {
          this.loadCreatedOrdersByOrderNumber({
            id: this.orderId,
            pageNumber: this.page,
            pageSize: this.pageSize,
          });
          this.loadCreatedOreders({
            pageNumber: this.getCurrentPageForCreatedOrders,
            pageSize: this.pageSize,
            orderNumber: null,
          })
        },
      })
    },

    editMaterial(item) {
      this.editMat = item;
      this.$bvModal.show('modal-edit-dress');
    },

    articleNAME(value) {
      this.articleee = value
    },

    materialsData(obj) {
      this.materialObject = obj;
      this.addTeamToArticle();
    },
    // materialsData

    immediateId(e) {
      this.$emit('click', e);
    },
    matProps(article) {
      this.materialPropId = article.materialId;
      this.classNameCh = article.colorName;
    },
  },
};
</script>

<style scoped lang="scss">
.editButton {
  height: 30px;
}
.button{
  height: 34px;
  margin-bottom:0px !important
}
.button:hover{
  height: 34px;
  margin-bottom:0px !important
}
.team_table td {
  padding: 12px 9px !important;
}

.color-listing__wrapper {
  margin-left: 5px;
  .mats-listing {
    margin-top: 0;
  }
  .table__search-input {
    visibility: hidden;
  }
  input {
    width: 100px;
  }
}



@media screen and (max-width: 1200px) {
  .color-listing__wrapper {
    margin-left: 0px
}
}
</style>
